define('shared/initializer/form/adapters/mixins/AfterSubmitActionTriggerable',[
    'shared/lib/RSVP',
    'shared/util/registers/ActionProvider',
    'shared/util/dom/form/enable'
], 
function (
    RSVP, 
    ActionProvider,
    enableForm
) {
    'use strict';

    function Ctor() { }

    function getAfterSubmitOptions() {
        var me = this;
        var options = me.options.action && 
            me.options.action.aftersubmit;
        return options || {};
    }

    function getTarget() {
        var me = this;
        var targetId = getAfterSubmitOptions.call(me).target || null;

        return targetId;
    }

    function getAction() {
        var me = this;
        var action = getAfterSubmitOptions.call(me).name || null;

        return action;
    }

    function getParam(){
        var me = this;
        var param = getAfterSubmitOptions.call(me).param || null;

        return param;
    }

    Ctor.prototype.doPageLoad = function() {
        var me = this;
        var $form = me.$form;
        var targetId = getTarget.call(me);
        var action = getAction.call(me);

        if (targetId == null || action == null) {
            return RSVP.resolve();
        }
        
        return ActionProvider.instance
            .get( targetId, action )
            .then(function( entity ){
                entity.actions[action].triggers.push($form[0]);
            });
    };

    Ctor.prototype.doAfterSubmit = function(data) {
        var me = this;
        var targetId = getTarget.call(me);
        var action = getAction.call(me);
        var param = getParam.call(me);

        if (targetId == null || action == null) {
            return RSVP.resolve(data);
        }

        return RSVP.resolve()
            .then(function(){
                var addtionalParam = {
                    form: me,
                    currentTarget: me.$form,
                    promise: null
                };
                ActionProvider.instance.trigger(targetId, action, param, addtionalParam);
                if (!addtionalParam.promise) {
                    addtionalParam.promise = new RSVP.resolve();
                }

                return addtionalParam.promise.then(function(){
                    if (getAfterSubmitOptions.call(me).hideThrubber) {
                        return me.resume();
                    }
                    else {
                        return RSVP.resolve();
                    }
                });
            })
            .then(function(){
                if (getAfterSubmitOptions.call(me).enableForm) {
                    enableForm(me.$form);
                }
            })
            .then(function(){
                return data;
            });
        
    };

    return Ctor;
});
